module.exports = __webpack_public_path__ + "img/receipt2.977ef0e6.png";